// ASSET
export const NAME_PATH = 'name';
export const ID_PATH = 'id';
export const EMAIL_PATH = 'email';
export const FEE_DESCRIPTION_PATH = 'feeDescription';
export const LEGACY_ID_PATH = 'legacyId';
export const ORG_ID_PATH = 'orgId';
export const ORG_REF_ID_PATH = 'orgRefId';
export const LATITUDE_PATH = 'latitude';
export const LONGITUDE_PATH = 'longitude';
export const PHONE_PATH = 'phone';
export const DESCRIPTION_PATH = 'description';
export const DIRECTIONS_PATH = 'directions';
export const KEYWORDS_PATH = 'keywords';
export const STAY_LIMIT_PATH = 'stayLimit';

// ADDRESS
export const ADDRESS2_PATH = 'address2';
export const ADDRESS3_PATH = 'address3';
export const ADDRESS1_PATH = 'address1';
export const CITY_PATH = 'city';
export const STATE_PATH = 'stateCode';
export const POSTAL_CODE_PATH = 'postalCode';
export const COUNTRY_PATH = 'countryCode';